import { SalesActionList, SalesType } from "../actions/salesActions"
import { Action } from "../actions/types"

const initialValue: Array<SalesType> = []

const salesReducer = (state: Array<SalesType> = initialValue, action: Action) => {
    switch (action.type) {

        case SalesActionList.ADD_SALES:
            return [
                ...state,
                action.data,
            ]

        case SalesActionList.UPDATE_SALES:
            const updated = [...state].slice()
            const index = updated.findIndex(u => u.id === action.data.id)

            if (index > -1) {
                updated[index] = {
                    ...action.data
                }
            }

            return updated

        case SalesActionList.FETCH_SALES:
            return action.data

        case SalesActionList.DELETE_SALES:
            return state.filter(s => s.id !== action.data)

        default:
            return state
    }
}

export default salesReducer